import React from 'react';
import { FaStar } from 'react-icons/fa';
import { motion } from 'framer-motion';
import testimonialsData from '../data/testimonialsData';
import '../styles/Testimonials.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonials = () => {
  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.6 
      } 
    }
  };

  // Render star rating
  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <FaStar 
        key={i} 
        className={i < rating ? 'filled' : 'empty'} 
      />
    ));
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <h2>What Our Clients Say</h2>
          <p>Hear from our satisfied customers across Delhi NCR</p>
          <p className="section-subtitle" style={{ color: 'var(--text-muted)' }}>
            Some clients opt for light-touch Vastu or zodiac cues—we’re happy to incorporate them tastefully.
          </p>
        </div>
        
        <motion.div 
          className="testimonials-grid"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          {testimonialsData.map((testimonial) => (
            <motion.div 
              key={testimonial.id} 
              className="testimonial-card"
              variants={item}
              whileHover={{ y: -5 }}
            >
              <div className="testimonial-content">
                <p className="testimonial-text">{testimonial.review}</p>
                <div className="rating">
                  {renderStars(testimonial.rating)}
                </div>
                <div className="testimonial-project">
                  {testimonial.project} • {testimonial.date}
                </div>
              </div>
              <div className="testimonial-meta">
                <div className="testimonial-avatar">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <div className="testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.location}, NCR</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
